import { IStatusBoxProps } from 'iglooform/es/status-box';
import { defineMessages } from 'react-intl';
export const statusTypes = {} as { [key: string]: IStatusBoxProps['type'] };

export const statusContents = {};

export const withdrawalStatus: any = defineMessages({
  WithdrawalRejected: { id: 'Rejected' },
  WithdrawalPending: { id: 'Pending' },
  WithdrawalProcessing: { id: 'Processing' },
  WithdrawalApproved: { id: 'Approved' },
  WithdrawalCompleted: { id: 'Completed' },
  WithdrawalFailed: { id: 'Failed' },
});

export const withdrawalStatusTypes = {
  WithdrawalRejected: 'error',
  WithdrawalPending: 'warning',
  WithdrawalProcessing: 'waiting',
  WithdrawalApproved: 'success',
  WithdrawalCompleted: 'success',
  WithdrawalFailed: 'failed',
} as { [key: string]: IStatusBoxProps['type'] };

export const PolicyStatus: any = defineMessages({
  PolicyIssued: { id: 'Policy issued' },
  PolicyProtected: { id: 'Policy protected' },
  PolicyTerminated: { id: 'Policy terminated' },
  PolicyEnded: { id: 'Policy ended' },
  PolicyExpired: { id: 'Policy expired' },
  PolicyActivated: { id: 'Policy protected' },
  PolicyPaymentProcessing: { id: 'Policy processing' },
  PolicyProcessing: { id: 'Policy processing' },
});

export const PolicyStatusType = {
  PolicyIssued: 'success',
  PolicyProtected: 'success',
  PolicyTerminated: 'failed',
  PolicyEnded: 'failed',
  PolicyExpired: 'failed',
  PolicyActivated: 'success',
  PolicyPaymentProcessing: 'warning',
  PolicyProcessing: 'warning',
} as { [key: string]: IStatusBoxProps['type'] };

export const QuotationStatus: any = defineMessages({
  QuoteInternalProcessing: { id: 'Underwriting' },
  QuoteInternalRejected: { id: 'Rejected' },
  QuoteInsurerProcessing: { id: 'Underwriting' },
  QuoteInsurerRejected: { id: 'Rejected' },
  QuoteEPolicyUploaded: { id: 'Expired' },
  QuotePaymentPending: { id: 'Payment Pending' },
  QuotePaymentProcessing: { id: 'Payment Processing' },
  QuoteConverted: { id: 'Converted' },
  QuoteExpired: { id: 'Expired' },
  QuotePaymentFailed: { id: 'Payment Failed' },
  QuoteCreated: { id: 'Created' },
  QuotePreSubmitted: { id: 'Created' },
  QuoteSubmitted: { id: 'Submitted' },
  QuotePaymentSuccess: { id: 'Payment Success' },
  Underwriting: { id: 'Underwriting' },
});

export const QuotationStatusType = {
  QuoteInternalProcessing: 'waiting',
  QuoteInternalRejected: 'error',
  QuoteInsurerProcessing: 'warning',
  QuoteInsurerRejected: 'error',
  QuoteEPolicyUploaded: 'waiting',
  QuotePaymentPending: 'warning',
  QuotePaymentProcessing: 'waiting',
  QuoteConverted: 'waiting',
  QuoteExpired: 'failed',
  QuotePaymentFailed: 'error',
  QuoteCreated: 'waiting',
  QuotePreSubmitted: 'waiting',
  QuoteSubmitted: 'waiting',
  QuotePaymentSuccess: 'success',
  Underwriting: 'warning',
} as { [key: string]: IStatusBoxProps['type'] };

export const VerificationStatusType = {
  0: 'error',
  1: 'warning',
  2: 'success',
  3: 'error',
} as { [key: string]: IStatusBoxProps['type'] };

export const VerificationStatus: any = defineMessages({
  1: { id: 'Unverified' },
  2: { id: 'Verified' },
  3: { id: 'Denied' },
});
